var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-mask" }, [
    _c("div", { staticClass: "modal-wrapper" }, [
      _c("div", { staticClass: "modal_size md_size" }, [
        _c(
          "a",
          {
            staticClass: "ui_close",
            attrs: { href: "javascript:", type: "button" },
            on: {
              click: function($event) {
                return _vm.$emit("close")
              }
            }
          },
          [_c("span", { staticClass: "sr_only" })]
        ),
        _vm._v(" "),
        _c("dl", { staticClass: "modal_content" }, [
          _c("dt", { staticClass: "ellipsis" }, [
            _c("i", [
              _vm._v(_vm._s(_vm.$t("TITLE.APPROVAL.HISTORY.POPUP.TITLE")))
            ])
          ]),
          _vm._v(" "),
          _c("dd", [
            _c("table", { staticClass: "create_table btmLine mt-20" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("tbody", [
                _c("tr", [
                  _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.SUBJECT")))]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      "\n                                    " +
                        _vm._s(_vm._f("decodeXSS")(_vm.approvalSubject)) +
                        "\n                                "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [_vm._v("History")]),
                  _vm._v(" "),
                  _c("td", { staticClass: "in_gird_table" }, [
                    _c("table", { staticClass: "scroll_table sm_grid" }, [
                      _vm._m(1),
                      _vm._v(" "),
                      _c("thead", { staticClass: "text_center" }, [
                        _c("tr", [
                          _c("th", { attrs: { colspan: "3" } }, [
                            _vm._v(
                              _vm._s(_vm.$t("FIELD.APPROVAL.PERSON.CHARGE"))
                            )
                          ]),
                          _vm._v(" "),
                          _c("th", [
                            _vm._v(_vm._s(_vm.$t("FIELD.APPROVAL.TITLE")))
                          ]),
                          _vm._v(" "),
                          _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.USER.TEAM")))]),
                          _vm._v(" "),
                          _c("th", [
                            _vm._v(_vm._s(_vm.$t("BUTTON.FAST.DATE")))
                          ]),
                          _vm._v(" "),
                          _c("th", [
                            _vm._v(_vm._s(_vm.$t("TITLE.GLOBAL.APPROVAL")))
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "tbody",
                        { staticClass: "text_center scroll height_185" },
                        _vm._l(_vm.approvalPath, function(item, index) {
                          return _c("tr", { key: index }, [
                            _c("td", { staticClass: "ellipsis" }, [
                              _vm._v(
                                "\n                                                    " +
                                  _vm._s(index) +
                                  "\n                                                "
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "text_left ellipsis" }, [
                              _vm._v(
                                "\n                                                    " +
                                  _vm._s(_vm.getRoleNm(item.APLN_ROLE)) +
                                  "\n                                                "
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                staticClass: "text_left ellipsis",
                                attrs: { title: item.NAME }
                              },
                              [
                                _vm._v(
                                  "\n                                                    " +
                                    _vm._s(item.NAME) +
                                    "\n                                                "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                staticClass: "ellipsis",
                                attrs: { title: item.JOB_POSITION }
                              },
                              [
                                _vm._v(
                                  "\n                                                    " +
                                    _vm._s(item.JOB_POSITION) +
                                    "\n                                                "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                staticClass: "ellipsis",
                                attrs: { title: item.DEPARTMENT_NAME }
                              },
                              [
                                _vm._v(
                                  "\n                                                    " +
                                    _vm._s(item.DEPARTMENT_NAME) +
                                    "\n                                                "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("td", { staticClass: "ellipsis" }, [
                              _vm._v(
                                "\n                                                    " +
                                  _vm._s(_vm.getActPrssDt(item.ACT_PRSS_DT)) +
                                  "\n                                                "
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                staticClass: "ellipsis",
                                attrs: { title: item.STATUS }
                              },
                              [
                                _vm._v(
                                  "\n                                                    " +
                                    _vm._s(item.STATUS) +
                                    "\n                                                "
                                )
                              ]
                            )
                          ])
                        }),
                        0
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [
                    _vm._v(_vm._s(_vm.$t("FIELD.APPROVAL.POPUP.APPROVEOPTION")))
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      "\n                                    " +
                        _vm._s(_vm.approvalOption) +
                        "\n                                "
                    )
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "154px" } }),
      _vm._v(" "),
      _c("col", { staticClass: "*" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "35px" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "120px" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "100px" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "100px" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "80px" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "100px" } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4db19050", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4db19050","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/common/popup/ApprovalHistoryPopup.vue
// module id = 6Kl+
// module chunks = 0